import httpClient from '/src/utils/httpClient';

// Block-level API calls

export function updateTipBlockApiCall({ id, isPathDesign, ...fields }) {
  const url = isPathDesign ? `api/tip-blocks/${id}/design` : `api/tip-blocks/${id}`;
  return httpClient.put(url, fields);
}

export function updateTipContainerDesignApiCall(blockId, containerDesign) {
  return httpClient.put(`api/tip-blocks/${blockId}/design/container`, containerDesign);
}

export function updateTipButtonDesignApiCall(blockId, buttonDesign) {
  return httpClient.put(`api/tip-blocks/${blockId}/design/button`, buttonDesign);
}

export function sortTipItemsApiCall(blockId, items) {
  return httpClient.put(`api/tip-blocks/${blockId}/items/sort`, { blockId, items });
}

// Tip item API calls

export function addTipItemQuickApiCall(profileId, fields) {
  return httpClient.post(`api/profiles/${profileId}/tips/quick`, fields);
}

export function addTipItemApiCall(profileId, fields) {
  return httpClient.post(`api/profiles/${profileId}/tips`, fields);
}

export function getTipItemApiCall(profileId, id) {
  return httpClient.get(`api/profiles/${profileId}/tips/${id}`);
}

export function updateTipItemApiCall(profileId, id, fields) {
  return httpClient.put(`api/profiles/${profileId}/tips/${id}`, fields);
}

export function updateTipItemSettingsApiCall(profileId, id, settings) {
  return httpClient.put(`api/profiles/${profileId}/tips/${id}/settings`, settings);
}

export function deleteTipItemApiCall(profileId, id) {
  return httpClient.delete(`api/profiles/${profileId}/tips/${id}`);
}

export function updateTipCheckoutFieldsApiCall(profileId, itemId, fields) {
  return httpClient.put(`api/profiles/${profileId}/tips/${itemId}/checkout/fields`, fields);
}

// Tip amounts API calls

export function addTipAmountApiCall(profileId, tipId, fields) {
  return httpClient.post(`api/profiles/${profileId}/tips/${tipId}/amounts`, fields);
}

export function updateTipAmountApiCall(profileId, tipId, amountId, fields) {
  return httpClient.put(`api/profiles/${profileId}/tips/${tipId}/amounts/${amountId}`, fields);
}

export function sortTipAmountsApiCall(profileId, tipId, items) {
  return httpClient.put(`api/profiles/${profileId}/tips/${tipId}/amounts/sort`, { items });
}

export function deleteTipAmountApiCall(profileId, tipId, amountId) {
  return httpClient.delete(`api/profiles/${profileId}/tips/${tipId}/amounts/${amountId}`);
}
